import { ListIcon } from '@calizahq/react-components-v2'
import React from 'react'

import { BottomSheet } from '@/components'
import { FilterOption } from '@/components/ListFilter/components'
import { useToggle } from '@/hooks'

interface MobileBreadcrumbsProps {
  activeBreadcrumbIndex: number
  breadcrumbs: {
    label: string
    value: string
  }[]
  setActiveBreadcrumb: (value: string) => void
}

export const MobileBreadcrumbs = ({
  activeBreadcrumbIndex,
  breadcrumbs,
  setActiveBreadcrumb,
}: MobileBreadcrumbsProps) => {
  const { isShown: modalShown, toggle: modalToggle } = useToggle()

  const handleApplyFilters = (index) => {
    setActiveBreadcrumb(breadcrumbs[index].value)
    modalToggle()
  }

  return (
    <div className="flex lg:hidden">
      <ListIcon className="w-6 cursor-pointer" onClick={modalToggle} />
      <BottomSheet header="Locations" isVisible={modalShown} onClose={modalToggle}>
        <div className="flex w-full flex-col px-6">
          {breadcrumbs.map((breadcrumb, index) => {
            return (
              <FilterOption
                key={index}
                label={breadcrumb.label}
                name={breadcrumb.value}
                onSelect={() => handleApplyFilters(index)}
                value={activeBreadcrumbIndex === index}
              />
            )
          })}
        </div>
      </BottomSheet>
    </div>
  )
}
